import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { styled } from "@mui/material";
import { isValidSession } from "@kahunmedical/user-management";
import { useHistory } from "react-router-dom";
import { useScreenSize } from "../../util/useScreenSize";
import { useDiagnosticNavigation } from "../../useDiagnosticNavigation";
import { UserManagementPopupMode } from "../../../../context/diagnosticAgent";
import { UsernameLoginWidget } from "../../../userManagement/usernameLoginWidget";

//region [[ Styles ]]

const SignInOrUserSectionView = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SignInOrUserSectionProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SignInOrUserSection = ({ ...props }: SignInOrUserSectionProps) => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const history = useHistory();
  const { isMobile } = useScreenSize();
  const { setLoginPopupState, loginPopupState } = useDiagnosticNavigation();

  // If login pop-up state was changed see if user got logged in
  useEffect(() => {
    if (
      loginPopupState === UserManagementPopupMode.Closed ||
      loginPopupState === UserManagementPopupMode.Logout
    ) {
      (async () => {
        const isValid = await isValidSession();
        setIsUserLoggedIn(isValid);
      })();
    }
  }, [loginPopupState]);

  const goToLogin = useCallback(() => {
    if (isMobile) {
      // TODO: use navigate to
      history.push({
        pathname: `/agent/login`,
        search: `?nextUrl=${encodeURIComponent(history.location.pathname)}`,
      });
    } else {
      setLoginPopupState(UserManagementPopupMode.Login);
    }
  }, [isMobile, history, setLoginPopupState]);

  const handleLogout = useCallback(() => {
    setLoginPopupState(UserManagementPopupMode.Logout);
  }, [setLoginPopupState]);

  return (
    <SignInOrUserSectionView>
      <UsernameLoginWidget
        onLogoutClicked={handleLogout}
        onLoginClicked={goToLogin}
        isUserLoggedIn={isUserLoggedIn}
      />
    </SignInOrUserSectionView>
  );
};
